import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APIHandler, AddFavorite, Image, DataHandler } from 'C4';

import appContent from 'helpers/appContent';

const TrainingImage = ({ contentComplete, image, imageCredits, pageID, type, upID }) => {
  const url = appContent(image);
  const href = APIHandler.getDownloadURL(url);

  return (
    <div className={clsx('trainingContent__image', { [type.toLowerCase()]: type !== undefined })}>
      <div className="trainingContent__image--wrapper">
        <Image src={url} load={contentComplete} alt={imageCredits} caption={imageCredits} fancybox={{ href }} />
        {imageCredits && <h3>{imageCredits}</h3>}
        <span className="zoomIcon">
          <FontAwesomeIcon icon={['far', 'search-plus']} />
        </span>
        {type === 'Photo' && <AddFavorite appId={DataHandler.matchAppId()} viewType="p" upID={upID} pageID={pageID} />}
      </div>
    </div>
  );
};

export default TrainingImage;

TrainingImage.propTypes = {
  contentComplete: PropTypes.func.isRequired,
  image: PropTypes.string.isRequired,
  imageCredits: PropTypes.string,
  pageID: PropTypes.string,
  type: PropTypes.string,
  upID: PropTypes.string,
};

TrainingImage.defaultProps = {
  imageCredits: '',
  type: '',
  upID: '',
  pageID: '',
};
